import { keyframes } from "styled-components";
import getColor from "../utils/getColor";
var overlayAnimation = function overlayAnimation(theme, customColor) {
  return keyframes(["from{background-color:transparent;}to{background-color:", ";}"], theme ? getColor(theme, "overlay") : customColor);
};
export default overlayAnimation;